module.exports = __webpack_public_path__ + "static/media/trophy.75a5f0c2.svg";